import { Component, ViewEncapsulation } from "@angular/core";
import { ICellRendererAngularComp } from "ag-grid-angular";
import { ICellRendererParams } from "ag-grid-community";

@Component({
  selector: "ngx-request-approve-column",
  template: `
    <span *ngIf="data.state !== 'WAIT'">
      {{data.state | approvalState}}
    </span>
    <span *ngIf="data.state === 'WAIT'">
      <button nbButton status="primary" size="tiny" (click)="saveApprove()">
        승인
      </button>
      <button nbButton size="tiny" status="danger" class="ml-2" (click)="saveDenied()">
        반려
      </button>
    </span>
  `,
  encapsulation: ViewEncapsulation.None,
})
export class RequestApproveComponent implements ICellRendererAngularComp {

  public params: ICellRendererParams;
  public data: any;

  constructor() { }

  refresh(params: ICellRendererParams): boolean {
    return false;
  }

  agInit(params: ICellRendererParams): void {
    this.params = params;
    this.data = this.params.data;
  }

  ngOnInit() { }

  saveApprove(): void {
    this.params.context.saveApprove(this.data);
  }

  saveDenied(): void {
    this.params.context.saveDenied(this.data);
  }
  
}
